import { Block_List_ItemQuery } from '@geerd-nx/shareable-graphql';

const goToBlockEdit = (
  blockItem: Block_List_ItemQuery['block_list_item'][number]
) => {
  switch (blockItem.type) {
    case 'fill_blank':
      return `/admin/blocks/fillblank/${blockItem.fillBlankId}`;
    case 'quiz':
      return `/admin/blocks/quiz/${blockItem.quizId}`;
    case 'text':
      return `/admin/blocks/text/${blockItem.textId}`;
    case 'dnd':
      return `/admin/blocks/dnd/${blockItem.dndId}`;
    default:
      return '';
  }
};

const getBlockId = (
  blockItem: Block_List_ItemQuery['block_list_item'][number]
) => {
  switch (blockItem.type) {
    case 'fill_blank':
      return blockItem.fillBlankId;
    case 'quiz':
      return blockItem.quizId;
    case 'text':
      return blockItem.textId;
    case 'media':
      return blockItem.mediaId;
    default:
      return NaN;
  }
};
const getBlockType = (
  blockItem: Block_List_ItemQuery['block_list_item'][number]
) => {
  switch (blockItem.type) {
    case 'media':
      return blockItem.media?.type;
    default:
      return blockItem.type;
  }
};

const getColumnName = (blockItem: string) => {
  switch (blockItem) {
    case 'fill_blank':
      return 'fillBlankId';
    case 'quiz':
      return 'quizId';
    case 'text':
      return 'textId';
    case 'media':
      return 'mediaId';
    case 'dnd':
      return 'dndId';
    default:
      return '';
  }
};

export { getBlockId, getColumnName, getBlockType, goToBlockEdit };
